import { NATIVE_APP_NAME } from '@/config';

class Mobile {
  /* eslint-disable */
  callNative(url) {
    if (this.isIOS()) {
      window.location = url;
    } else {
      if (!window.ctandroid) {
        // android under 4.2
        window.prompt(url);
      } else {
        window.ctandroid.submitFromWeb(url);
      }
    }
  }

  openNewWebView(url) {
    this.callNative(`ctjscall://open?source=${NATIVE_APP_NAME}&url=${encodeURIComponent(url)}`);
  }

  closeWebView() {
    this.callNative(`ctjscall://close?source=${NATIVE_APP_NAME}`);
  }

  isMobile() {
    return this.isIOS() || this.isAndroid();
  }

  isIOS() {
    const userAgent = window.navigator.userAgent;

    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      return true;
    }

    return false;
  }

  isAndroid() {
    const userAgent = window.navigator.userAgent;

    if (userAgent.match(/android/i)) {
      return true;
    }

    return false;
  }

  callActionbar(isVisible) {
    this.callNative(`ctjscall://navigation?source=classting&is_visible=${isVisible}`);
  }

  getClasstingAndroidVersion() {
    const userAgent = window.navigator.userAgent;
    const regex = /classting_android,\s([0-9]).([0-9]).([0-9])*/;
    const match = regex.exec(userAgent.toLowerCase());

    if (match) {
      const currentVersion = Number(match.slice(1, 4).join(''));
      return currentVersion;
    }

    return 0;
  }

  getAndroidVersion() {
    const userAgent = window.navigator.userAgent;
    const regex = /android\s([0-9]*)/;
    const match = regex.exec(userAgent.toLowerCase());

    if (match) {
      return match[1];
    }

    return 0;
  }

  isClasstingClient() {
    return this.isClasstingIos() || this.isClasstingAndroid();
  }

  isClasstingAndroid() {
    const userAgent = window.navigator.userAgent;
    const regex = /classting_android,\s([0-9])*/;
    const match = regex.exec(userAgent.toLowerCase());

    if (match) {
      return true;
    }

    return false;
  }

  isClasstingIos() {
    const userAgent = window.navigator.userAgent;
    const regex = /classting_iphone/;
    const match = regex.exec(userAgent.toLowerCase());

    if (match) {
      return true;
    }

    return false;
  }

  isOldAndroid() {
    if (this.isAndroid() && this.compareVersions(this.getAndroidVersion(), '5.0.0') < 0) {
      return true;
    }

    return false;
  }

  compareVersions(left, right) {
    if (!(typeof left === 'string' && typeof right === 'string')) {
      return false;
    }

    const a = left.split('.');
    const b = right.split('.');
    const len = Math.max(a.length, b.length);

    for (let i = 0; i < len; i += 1) {
      if ((a[i] && !b[i] && parseInt(a[i], 10) > 0) ||
        (parseInt(a[i], 10) > parseInt(b[i], 10))) {
        return 1;
      } else if ((b[i] && !a[i] && parseInt(b[i], 10) > 0) ||
        (parseInt(a[i], 10) < parseInt(b[i], 10))) {
        return -1;
      }
    }

    return 0;
  }
}

export const mobile = new Mobile();

export default function install(Vue) {
  Object.defineProperty(Vue.prototype, '$mobile', {
    get() {
      return mobile;
    },
  });
}



// WEBPACK FOOTER //
// ./src/plugins/mobile/index.js